export default __webpack_public_path__ + "static/media/pgmico(34).300a7cb9.png";